<template>
  <div class="main-footer-container text-dark mt-5 mb-5" :class="darkMode ? 'text-white' : 'text-dark'">
    <div style="width: 100%">
      <b-row class="m-0 justify-content-center mx-3">
        <p v-if="!checkShopMode" class="custom-nav mr-1 pt-1 hover hover-3" @click="$router.push('/').catch(err => {})">Home</p>
        <p v-if="!checkShopMode" class="pt-1 pr-1">|</p>
        <p class="custom-nav mr-1 pt-1 hover hover-3" @click="$router.push('/datenschutz').catch(err => {})">Datenschutzerklärung</p>
        <p class="pt-1 pr-1">|</p>
        <p class="custom-nav mr-1 pt-1 hover hover-3" @click="$router.push('/impressum').catch(err => {})">Impressum</p>
        <p class="pt-1 pr-1">|</p>
        <p class="custom-nav mr-1 pt-1 hover hover-3" @click="$router.push('/empfehlung').catch(err => {})">Ein Restaurant empfehlen</p>
        <p class="pt-1 pr-1 ">|</p>
        <p class="custom-nav mr-1 pt-1 hover hover-3" @click="windowOpen('https://info.eatdorado.de')">Mein Restaurant anmelden</p>
        <p class="pt-1 pr-1">|</p>
        <p class="custom-nav pt-1 hover hover-3" @click="relaodModal = true">App neu laden</p>
      </b-row>
      <b-row class="m-0 pb-3 justify-content-center mx-3">
        <font-awesome-icon class="custom-nav text-dark" @click="windowOpen('https://www.facebook.com/eatDorado')" style="font-size: 30px" :icon="['fab', 'facebook-square']"/>
        <font-awesome-icon class="custom-nav ml-3 text-dark" @click="windowOpen('https://www.instagram.com/eatdorado/')" style="font-size: 30px" :icon="['fab', 'instagram']"/>
      </b-row>
      
      <b-row class="m-0 pb-2 justify-content-center mx-3">
        <p>© {{ new Date().getFullYear() }} eatDorado.de</p>
      </b-row>
      <b-row class="m-0 pb-2 justify-content-center mx-3">
        <b-img-lazy  :src="require(`@/assets/logos/eatDoradoText.png`)" style="max-height: 30px" fluid alt="eatDorado Logo"></b-img-lazy>
      </b-row>
    </div>
    <b-modal id="infoModal" v-model="relaodModal" centered hide-footer hide-header>
      <div class="bg-white" style="border-radius: 10px; transition: all .5s;">
        <b-row class="m-0 p-3 justify-content-between" style="border-top-left-radius: 10px; border-top-right-radius: 10px;">
          <h4 class="ml-2 text-center text-dark">Cache löschen und App neu laden?</h4>
          <font-awesome-icon @click="relaodModal = false" style="font-size: 30px; cursor: pointer" :icon="['fas', 'times']"/>
        </b-row>
        <div class="m-3 pb-5">
          <p class="text-left">Solltest du bereits Gerichte im Warenkorb haben, werden diese gelöscht. Auch der Aktuelle Standort wird zurückgesetzt. <br> Diese Aktion wird empfohlen, wenn unvorhergesehene Fehler auftreten sollten.</p>
          <b-row class="m-0 justify-content-around">
            <b-button variant="warning" @click="reloadApp">App neu laden</b-button>
            <b-button variant="secondary" @click="relaodModal = false">abbrechen</b-button>
          </b-row>

        </div>
      </div>
    </b-modal>
    <cookie-banner/>
  </div>
</template>

<script>
import CookieBanner from './CookieBanner'

export default {
  name: 'Footer',
  data() {
    return {
      relaodModal: false,
      year: new Date().getFullYear(),
      visible: false
    };
  },
  components: {
     CookieBanner,
  },
  props: {

  },
  computed: {
    restaurant(){
      return this.$store.getters.restaurant
    },
    darkMode(){
      return this.$store.getters.darkMode
    },
    checkShopMode(){
      if(this.$route.params.id){
        if(!this.restaurant) return false
        if(this.$route.params.id == this.restaurant.url){
          return true
        }
      }
      return false
    }
  },
  methods: {
    reloadApp(){
      localStorage.clear()
      window.location.reload()
      // this.$router.push('/').catch(() => {})
    },
    windowOpen(link){
        window.open(link, "_blank")
    },
    scollToBottom(){
      this.visible = !this.visible
    }
  }
}
</script>

<style scoped>

  .main-footer-container{
    /* padding-top: auto; */
    text-align: center;
    position:relative;
    min-height: 50px;
    width: 100%;
  }

</style>
